// ─────────────────────────────────────────────────────────────────────────
// RATING DISPLAY — Nunca mostrar estrellas falsas.
// ─────────────────────────────────────────────────────────────────────────
// El usuario fue claro: un perfil sin viajes NO puede aparecer con ⭐5.0.
// Las estrellas solo tienen sentido cuando hay calificaciones reales
// acumuladas (ratingCount > 0). Mientras tanto mostramos "Nuevo".
//
// Uso:
//   const r = ratingDisplay(driver.rating, driver.ratingCount);
//   r.isNew ? <Badge>Nuevo</Badge> : <Text>⭐ {r.label}</Text>
// ─────────────────────────────────────────────────────────────────────────

export interface RatingInfo {
  /** "5.0" para mostrar, o "Nuevo" si no hay calificaciones reales. */
  label: string;
  /** true cuando el perfil aún no tiene viajes calificados. */
  isNew: boolean;
}

export function ratingDisplay(
  rating?: number | string | null,
  ratingCount?: number | null
): RatingInfo {
  const n = typeof rating === 'string' ? parseFloat(rating) : (rating ?? NaN);
  const count = typeof ratingCount === 'number' ? ratingCount : 0;
  // Solo es "real" si hay al menos 1 calificación Y el número es válido.
  if (count > 0 && Number.isFinite(n) && n > 0) {
    return { label: n.toFixed(1), isNew: false };
  }
  return { label: 'Nuevo', isNew: true };
}
